import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import Input from "../../Nano/Input.js";
import Grid from "../../Macro/Grid.js";
import WrapperList from "./../../Nano/WrapperList.js";
import ViewMore from "./../../Nano/ViewMore.js";
import TitleCard from "./../../Nano/TitleCard.js";
import Spinner from "./../../Nano/Spinner.js";
import Modal from "../../Global/Modal.js";
import ModalContent from "../../Micro/ModalContent.js";

//IMAGES
import { ReactComponent as SavedSearches } from "../../Global/Icons/savedSearches.svg";
import { ReactComponent as Edit } from "../../Global/Icons/edit.svg";
import { ReactComponent as Delete } from "../../Global/Icons/delete.svg";
import { ReactComponent as Check } from "../../Global/Icons/check.svg";
import { ReactComponent as DeleteWarning } from "../../Global/Icons/delete.svg";

import searchService from "../../../services/SearchService.js";

const multiple = nota.global.multiple;

const StyledDailyUpdateManagement = styled(NanoFlex)`
  height: 100%;
  padding: ${multiple * 2 + "px"};

  .headerWrapper {
    height: auto;
    h2 {
      text-transform: uppercase;
      em {
        text-transform: none;
        font-weight: bold;
        color: ${nota.color.main.default};
      }
    }
    p {
      margin-left: ${multiple * 2 + "px"};
      margin-bottom: 2px;
      width: 60%;
    }
  }

  .secondaryWrapper {
    height: auto;
    margin: ${multiple * 3 + "px"} 0;
    .asideWrapper {
      width: auto;
    }
  }

  /* BUTTON ICON --- secondaryWrapper */
  .iconBtnsWrapper {
    cursor: pointer;
    background-color: ${nota.color.main.default};
    user-select: none;

    width: auto;
    height: 38px;
    padding: 8px;
    svg {
      width: 18px;
      height: 20px;
      path {
        fill: ${nota.color.neutral.white};
      }
    }
    p {
      margin-left: ${multiple + "px"};
      color: ${nota.color.neutral.white};
    }
    &:hover {
      opacity: 0.7;
    }
  }
  /* INPUT --- secondaryWrapper */
  .inputWrapper {
    width: auto;
    min-width: 250px;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .editIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      cursor: pointer;
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.neutral.NeuThree};
        }
      }
      &:hover {
        svg {
          path {
            fill: ${nota.color.neutral.NeuTwo};
          }
        }
      }
    }
  }
  /* SELECT BTN */
  .selectBtn {
    height: 38px;
    width: auto;
    margin-right: ${multiple + "px"};
    user-select: none;
    .optionWrapper {
      background-color: ${nota.color.neutral.NeuFour};
      width: 100%;
      cursor: pointer;
      padding: ${multiple + "px"};
      p {
        text-transform: uppercase;
      }
      .checkBoxWrapper {
        height: 100%;
        width: auto;
        padding-right: ${multiple + "px"};
        svg {
          width: 18px;
          height: 10px;
          path {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }

      &:hover {
        opacity: 0.7;
      }
    }
    .selectedOption {
      background-color: ${nota.color.main.default};
      p {
        color: ${nota.color.neutral.white};
      }
      .checkBoxWrapper {
        svg {
          path {
            fill: ${nota.color.neutral.white};
          }
        }
      }
    }
  }

  /* LIST */
  .listContainer {
    height: auto;

    .itemContainer {
      width: 50%;
      height: auto;

      .wrapperList {
        /* margin: 0; */
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .headerContainer {
          height: auto;
        }
        .titleCard {
          margin-top: ${multiple * 2 + "px"};
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple / 2 + "px"};
          width: 85%;
          height: auto;
          h3 {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .descriptionWrapper {
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple + "px"};
          width: 85%;
          height: auto;
          p {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .noInfo {
          margin-bottom: ${multiple + "px"};
          font-size: 12px;
          color: ${nota.color.neutral.NeuThree};
          line-height: unset;
          height: auto;
        }

        .gridContainer {
          min-height: 200px;
          .emptyGrid {
            background-color: ${nota.color.neutral.NeuFour};
            p {
              text-transform: uppercase;
            }
          }
        }
        .grid {
          padding: 0 ${multiple + "px"};
        }
        .bottomOptionsWrapper {
          padding: ${multiple + "px"} ${multiple * 2 + "px"};
          background-color: ${nota.color.neutral.lightGrey};
          height: auto;
          .bottomIcons {
            height: auto;
            svg {
              width: 14px;
              height: 14px;
              margin: 0 ${multiple + "px"};
              cursor: pointer;
              path {
                fill: ${nota.color.neutral.NeuOne};
              }
              &:hover {
                path {
                  fill: ${nota.color.main.default};
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
            .deleteBtn {
              &:hover {
                path {
                  fill: ${nota.color.main.mTwo};
                }
              }
            }
          }
        }
      }
      &:nth-child(odd) {
        .wrapperList {
          margin-left: 0;
        }
      }
      &:nth-child(even) {
        .wrapperList {
          margin-right: 0;
        }
      }
    }
  }

  /* NO ITEMS LIST INFO */
  .noItemsListInfo {
    height: calc(100vh - 284px);
    background-color: ${nota.color.neutral.NeuFour};
    h2 {
      text-transform: uppercase;
    }
  }
`;

export class SavedSearchItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      programs: null,
      programsCount: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevProps.savedSearch) !== JSON.stringify(this.props.savedSearch)) {
      this.getAllData();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);
  }

  onSavedSearchItemLanguageChange = () => {
    this.getAllData();
  };

  getAllData = () => {
    this.getPrograms();
  };

  getPrograms = () => {
    if (this.props.savedSearch.filter) {
      searchService
        .getAdvancedSearchPrograms({ ...this.props.savedSearch.filter, ...{ Page: 1, ResultsPerPage: 7, SearchFrom: "SavedSearch" } })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ programs: data.programs, programsCount: data.count });
        });
    } else {
      this.setState({ programs: [] });
    }
  };

  onDeleteClick = () => {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.savedSearch);
    }
  };

  onSearchClick = () => {
    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { id: this.props.savedSearch.id, menu: "SavedSearch", lastCall: this.props.savedSearch.lastCall, filter: this.props.savedSearch.filter } }));
  };

  render() {
    return (
      <NanoFlex className="itemContainer" alignItems={"stretch"}>
        <WrapperList className="wrapperList">
          <ViewMore onClick={this.onSearchClick} />

          <NanoFlex className="headerContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            <NanoFlex className="titleCard" justifyContent={"flex-start"}>
              <Type.h3 title={this.props.savedSearch.searchName}>
                <b>{this.props.savedSearch.searchName}</b>
              </Type.h3>
            </NanoFlex>
            <NanoFlex className="descriptionWrapper" justifyContent={"flex-start"}>
              {this.props.savedSearch.description && <Type.p title={this.props.savedSearch.description}>{this.props.savedSearch.description}</Type.p>}
              {!this.props.savedSearch.description && <Type.p className="noInfo">{this.translation.geral.noDescription}</Type.p>}
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="gridContainer">
            {this.state.programs?.length > 0 && <Grid className="gridItem" data={this.state.programs} row={1} />}
            {this.state.programs?.length == 0 && (
              <NanoFlex className="emptyGrid">
                <Type.p>No items</Type.p>
              </NanoFlex>
            )}

            {!this.state.programs && (
              <NanoFlex className="loagindGrid">
                <Spinner />
              </NanoFlex>
            )}
          </NanoFlex>
          <NanoFlex className="bottomOptionsWrapper">
            <NanoFlex className="bottomIcons" justifyContent={"flex-end"}>
              <Delete className="deleteBtn" onClick={this.onDeleteClick} />
            </NanoFlex>
          </NanoFlex>
        </WrapperList>
      </NanoFlex>
    );
  }
}

export class DailyUpdateManagement extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      savedSearches: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onDailyUpdateLanguageChange, false);
    window.addEventListener("saveSearch", this.onSaveSearch, false);

    this.getAllComponentsData();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onDailyUpdateLanguageChange, false);
    window.removeEventListener("saveSearch", this.onSaveSearch, false);
  }

  onDailyUpdateLanguageChange = () => {
    this.getAllComponentsData();
  };

  onSaveSearch = () => {
    this.getAllComponentsData();
  };

  getAllComponentsData = () => {
    this.getSavedSearches();
  };

  getSavedSearches = () => {
    searchService
      .getDailyUpdateSavedSearches()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ savedSearches: data });
      });
  };

  onEmailChange = (value) => {
    this.setState({ email: value });
  };

  onSavedSearchDelete = (item) => {
    this.setState({ savedSearchToDelete: item });
  };

  confirmSavedSearchDelete = () => {
    searchService
      .setSearchDailyUpdate(this.state.savedSearchToDelete.id, false)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ savedSearchToDelete: null }, () => {
          /*Get New Data */
          this.getAllComponentsData();
        });
      });
  };

  render() {
    return (
      <StyledDailyUpdateManagement>
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"center"}>
            <Type.h2>
              <em>MANAGE MY DAILY UPDATE</em>
            </Type.h2>
            <Type.p>Customizable newsletter, including latest, upcoming and noteworthy programmes selected by our editorial team</Type.p>
          </NanoFlex>

          <NanoFlex className="secondaryWrapper" justifyContent={"space-between"} alignContent={"flex-start"} alignItems={"flex-start"}>
            <NanoFlex className="asideWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
              <NanoFlex className="selectBtn" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <NanoFlex className="optionWrapper selectedOption" justifyContent="flex-start">
                  <NanoFlex className="checkBoxWrapper" justifyContent="flex-start">
                    <Check />
                  </NanoFlex>
                  <Type.p>ACTIVATE MY DAILY UPDATE</Type.p>
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                <Input title={null} defaultValue={this.state.email} placeholder={"email@email.com"} onChangeAction={this.onEmailChange} />
                <NanoFlex className="editIconWrapper">
                  <Edit />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="asideWrapper" justifyContent={"flex-end"} alignContent={"flex-end"} alignItems={"flex-end"}>
              <NanoFlex className="iconBtnsWrapper">
                <SavedSearches />
                <Type.p>MANAGE MY SAVED SEARCHES</Type.p>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          {/*LIST*/}
          <NanoFlex className="listContainer" flexDirection={"row"} flexWrap={"wrap"} justifyContent={"flex-start"} alignContent={"stretch"} alignItems={"stretch"}>
            {/* ITEM  */}
            {this.state.savedSearches &&
              this.state.savedSearches.map((item) => {
                return <SavedSearchItem savedSearch={item} key={item.id} onDelete={this.onSavedSearchDelete}></SavedSearchItem>;
              })}
            {/* END ITEM  */}
          </NanoFlex>
          {/* END LIST  */}
          {/* EMPTY LIST INFO  */}
          {this.state.savedSearches?.length == 0 && (
            <NanoFlex className="noItemsListInfo">
              <Type.h2>EMPTY lIST</Type.h2>
            </NanoFlex>
          )}
        </NanoFlex>

        {this.state.savedSearchToDelete && (
          <Modal
            show={true}
            content={
              <ModalContent
                title={
                  <NanoFlex>
                    <DeleteWarning className="modalIcon" />
                    <Type.h2>REMOVE</Type.h2>
                  </NanoFlex>
                }
                message={
                  <Type.p>
                    Are you sure you want to remove <b>"{this.state.savedSearchToDelete.searchName}"</b> from the Daily Update?
                  </Type.p>
                }
                actions={[
                  {
                    label: this.translation.geral.cancel,
                    action: () => {
                      this.setState({ savedSearchToDelete: null });
                    },
                    simple: true,
                  },
                  {
                    label: this.translation.geral.confirm,
                    action: this.confirmSavedSearchDelete,
                    simple: false,
                  },
                ]}
              />
            }
          />
        )}
      </StyledDailyUpdateManagement>
    );
  }
}
